import { render, staticRenderFns } from "./ModalStudentHandedData.vue?vue&type=template&id=fca2eccc&scoped=true"
import script from "./ModalStudentHandedData.vue?vue&type=script&lang=js"
export * from "./ModalStudentHandedData.vue?vue&type=script&lang=js"
import style0 from "./ModalStudentHandedData.vue?vue&type=style&index=0&id=fca2eccc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca2eccc",
  null
  
)

export default component.exports